import Analytics from '@jg/koala-front-end-analytics';
import { TrackingProvider } from '@jg/react-tracking';
import * as Sentry from '@sentry/browser';
// This unfortunately falls outside of our nomodule polyfill checking
// as there’s a version of Mobile Safari (early v11) that supports
// nomodule but doesn’t have AbortController
import 'abortcontroller-polyfill';
import 'lazysizes';
import React, { Suspense } from 'react';
import { render } from 'react-dom';
import config from './config';
import App from './containers/App';
import './i18next';
import getAppVersion from './lib/getAppVersion';

const analytics = new Analytics({ apiUrl: config.koalaUri });

if (config.sentry && config.sentry.dsn) {
  Sentry.init({
    ...config.sentry,
    release: getAppVersion() || '0',
    environment: config.environment,
  });
}

render(
  <TrackingProvider
    analytics={analytics}
    defaultTrackingData={{ page_type: 'one search' }}
  >
    <Suspense fallback={<div />}>
      <App />
    </Suspense>
  </TrackingProvider>,
  document.getElementById('app')
);
